import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Faltan VITE_SUPABASE_URL o VITE_SUPABASE_ANON_KEY en el archivo .env');
}

// No-op lock implementation.
//
// supabase-js v2 usa Web Locks API (`navigator.locks.request`) por defecto
// para coordinar el refresh del access token entre pestañas. En Playwright
// Chromium el lock no siempre se libera entre `page.goto` y la siguiente
// llamada de auth (`updateUser`, `getSession`, etc.) se queda colgada para
// siempre — síntoma visto en `set-password-flow.spec.ts` (botón
// "Guardando..." DISABLED indefinidamente, sin error ni navegación).
//
// El admin web es de un solo usuario por sesión (un admin o un monitor en
// una pestaña), así que la coordinación cross-tab no nos aporta nada: el
// auto-refresh interno de supabase-js sigue siendo serializado por
// instancia y por usuario. Pasamos un lock no-op que ejecuta la función
// directamente sin reservar nada.
//
// Referencia: https://github.com/supabase/auth-js (option `auth.lock`).
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    lock: async (_name, _acquireTimeout, fn) => fn(),
  },
});
